export enum CHAT_TYPE {
  ONE_TO_ONE = "ONE_TO_ONE",
  ROOM = "ROOM",
  SPACE = "SPACE",
}
